import { render } from "./walk.vue?vue&type=template&id=84b77a82&scoped=true"
import script from "./walk.vue?vue&type=script&lang=js"
export * from "./walk.vue?vue&type=script&lang=js"

import "./walk.vue?vue&type=style&index=0&id=84b77a82&lang=scss&scoped=true"
import "./walk.vue?vue&type=style&index=1&id=84b77a82&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b77a82"]])

export default __exports__